import React from 'react';
import styled from '@emotion/styled';

const AutoIcon = styled.div`
	display: flex;
	width: 48px;
	justify-content: space-between;
	height: 24px;

	div {
		width: 3px;
		height: 100%;
		background-color: currentColor;
	}
`;
export default () => (
	<AutoIcon data-testid="auto-spacing">
		<div />
		<div />
		<div />
	</AutoIcon>
);
